var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureIvmsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0178 32.9985C28.8558 32.9985 32.7778 29.0765 32.7778 24.2385C32.7778 19.4005 28.8558 15.4785 24.0178 15.4785C19.1798 15.4785 15.2578 19.4005 15.2578 24.2385C15.2578 29.0765 19.1798 32.9985 24.0178 32.9985Z",
    stroke: "#9C4900",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0156 45.7383C35.8897 45.7383 45.5156 36.1124 45.5156 24.2383C45.5156 12.3642 35.8897 2.73828 24.0156 2.73828C12.1415 2.73828 2.51562 12.3642 2.51562 24.2383C2.51562 36.1124 12.1415 45.7383 24.0156 45.7383Z",
    stroke: "#9C4900",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51562 24.2383H8.74562M39.2856 24.2383H45.5156",
    stroke: "#9C4900",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIvmsActive);
export default __webpack_public_path__ + "static/media/Feature_IVMS_active.86b17ad6b291a0363d7d96a3c6c63f06.svg";
export { ForwardRef as ReactComponent };